export const emailNotLongEnough = "Email must be at least 3 characters"
export const invalidEmail = "Please enter a valid email"
export const emailRequired = "Email is required"
export const emailTooLong = "Email max length reached"
export const resendEmailVerificationLink =
  "Please verify your email address by clicking on the link we just emailed you"
export const resendVerificationButton = "Resend verification link"
export const verifyEmailAddressMessage =
  "Please verify your email before proceeding"
export const verifyEmailMessage = "Email is not verified"

//password
export const passwordNotLongEnough = "Password must be at least 8 characters"
export const passwordRequired = "Password is required"
export const confirmPasswordRequired = "Confirm password is required"
export const passwordsMustMatch = "Passwords must match"
export const passwordTooLong = "Password max length reached"
export const passwordWeak =
  "Password is weak. Must contain atleast 1 uppercase, 1 lowercase, 1 digit and a special character."

//mobile validation
export const invalidMobileNumber = "Please Enter A Valid Mobile Number"
export const mobileNumberRequired = "Enter Your Mobile Number"
export const otpRequired = "OTP is required"
export const otpMin = "OTP Has To Be 4 Digits"
export const otpMax = "OTP Can Be max 4 Digits"
export const inviteeMobileRequired =
  "Enter the Mobile number you want to invite"

//Couplig page
export const phone = "Phone"
//limit to characters
export const minCharacters = 3
export const maxCharacters = 255
export const billingZipMinMax = 5
export const otpMinMax = 4
export const passwordMin = 8
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
